import * as React from 'react';
import { FC, useState } from 'react';
import { CasinoFiltersProps } from './types';

const SEARCH_TIMEOUT = 350; // ms

const NameFilter: FC<{
  value: string;
  onChange: (v: string) => void;
  locales: CasinoFiltersProps['locales'];
}> = ({ value, onChange, locales }) => {
  const [name, setName] = useState(value);
  const [loadTimeoutId, setLoadTimeoutId] = useState<number>();

  const changeValue = (v: string = name) => {
    if (!v.length || v.length >= 3) {
      onChange(v);
    }
  };

  const debouncedSearch = (v: string) => {
    setName(v);
    window.clearTimeout(loadTimeoutId);
    setLoadTimeoutId(
      window.setTimeout(() => {
        changeValue(v);
      }, SEARCH_TIMEOUT)
    );
  };

  return (
    <div className="search-form">
      <h4>{locales.search_games}</h4>
      <form
        onSubmit={(e) => {
          onChange(value);
          e.preventDefault();
        }}
      >
        <div className="rs-row rs-clear_after rs-padding__zero postfix-round">
          <div className="search_field">
            <input
              aria-label={locales.search}
              placeholder={locales.search}
              type="search"
              value={name}
              onChange={(e) => debouncedSearch(e.target.value)}
            />
          </div>
          <div className="search_button">
            <button type="submit" className="rs-button postfix" data-testid="search-button">
              <i className="rs-icon-search rs-text-size_medium" />
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default NameFilter;
